module.exports = __webpack_public_path__ + "static/media/DAI-BNB.ad5e9309.svg";